<template>
    <div class="container">
        <b-modal :model-value="showNewSegundoLev" :no-close-on-backdrop="true" hide-header hide-footer centered @hide="clicked">
            <div class="text-center">
                {{ labels.title }} 
            </div>
            <div>
                <b-row>
                    <b-col md="8" lg="7" class="mt-2 mx-auto">
                        <h5>{{ tituloNivUno(levelUnoSel) }}</h5>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="8" lg="7" class="mt-2 mx-auto">
                            <!-- <label>{{ labels.validity }}</label> --> 
                            <input
                                type="number"
                                name="name"
                                v-model="levelSecond"
                                placeholder="labels.levelSecond" 
                            />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="8" lg="7" class="mt-2 mx-auto">
                            <!-- <label>{{ labels.validity }}</label> --> 
                            <input
                                type="text"
                                name="name"
                                v-model="name"
                                placeholder="labels.name" 
                            />
                    </b-col>
                </b-row>
                <div class="mt-3">
                    <b-button class="md-primary" @click="newLevelSecond">{{ labels.save }}</b-button> 
                    <b-button class="md-accent" @click="clicked">{{ labels.close }}</b-button> 
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import SegundoNivel from "../../services/SegundoNivel" 
import PrimerNivel from "../../services/PrimerNivel" 
export default {
    name:"NewSecondLevel",
    props: ['showNewSegundoLev','levelUnoSel','CodigoReport'],
    data: () => ({
        name:"",
        levelSecond:"",
        nameFirstLevel:""
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : "Crear nivel",
                    save : "Guardar",
                    close : "Cerrar",
                    name : "Nombre",
                    levelSecond : "Segundo nivel (Números*)"
                }
            }else{
                return {
                    title : "Create level",
                    save : "Save",
                    close : "Close",
                    name : "Name",
                    levelSecond : "levelSecond (Number*)"
                }
            }
        }
    },
    methods: {
        clicked(){
            this.$emit('clickedSegundo',this.levelUnoSel,this.CodigoReport,false)
            this.name = ""
            this.levelSecond = ""
            this.levelThird = ""
        },
        newLevelSecond(){
            // console.log(this.levelUnoSel)
            if(this.name == ""){
                this.$toast.error("El campo Nombre debe estar diligenciado")
            
            }else if(this.levelSecond == ""){
                this.$toast.error("El campo Segundo nivel debe estar diligenciado")
            }else{
                let form = {
                    'primer_nivel'  : this.levelUnoSel,
                    'segundo_nivel' : this.levelSecond,
                    'descripcion'   : this.name,
                    'codReporte'    : this.CodigoReport,
                    'idUser'        : this.$store.state.userId,
                }
                // console.log(form) 
                SegundoNivel.createSecondLevel(form) 
                .then((res) => { 
                    // console.log(res) 
                    this.$toast.success(res.data.message)
                    this.clicked()
                })
                .catch((err) => { 
                    this.$toast.error(err.message)
                    console.log(err) 
                })
            }
        },
	tituloNivUno(nivUno){
  if (nivUno.length) { 
   PrimerNivel.getFirstLevelById(nivUno) 
   .then((res) => { 
				this.nameFirstLevel = res.data.firstLevelById[0].descripcion
			})
   .catch((error) => { 
    console.log(error) 
			})
		} else {
			this.nameFirstLevel = ""
		}
		return this.nameFirstLevel
	}
    }
}
</script>
<style src="../main.css"></style> 